import CreditreformIcon from "src/assets/CreditreformIcon.svg?react";
import {
  getDefaultCreditreformBriefReport,
  getDefaultCreditreformCommercialReport,
  getDefaultCreditreformCompactReport,
  getDefaultCreditreformEcrefoReport,
  getDefaultCreditreformIdentificationReport,
  getDefaultCreditreformRiskCheckReport,
  getDefaultCreditreformSearchRequest,
  getDefaultCreditreformTrafficLightReport,
  getDefaultCreditreformMailboxDirectory,
  getDefaultCreditreformMailboxEntry,
} from "src/connections/connectionConfigs/creditreform/creditreformResources";
import { CreditreformTemplate } from "src/connections/connectionConfigs/creditreform/creditreformTemplate";
import { ConnectionConfig } from "src/connections/connectionConfigs/types";

export const CREDITREFORM_CONFIG: ConnectionConfig<"creditreform"> = {
  icon: CreditreformIcon,
  template: CreditreformTemplate,
  description: "Providing B2B credit ratings and balance sheets",
  name: "Germany | Creditreform",
  resources: {
    brief_report: {
      externalLink:
        "https://docs.taktile.com/third-party-connections/built-in-connection-nodes/credit-bureaus/creditreform#brief-report-kurzauskunft",
      integrationResource: getDefaultCreditreformBriefReport,
    },
    commercial_report: {
      externalLink:
        "https://docs.taktile.com/third-party-connections/built-in-connection-nodes/credit-bureaus/creditreform#commercial-report-wirtschaftsauskunft",
      integrationResource: getDefaultCreditreformCommercialReport,
    },
    compact_report: {
      externalLink:
        "https://docs.taktile.com/third-party-connections/built-in-connection-nodes/credit-bureaus/creditreform#compact-report-kompaktauskunft",
      integrationResource: getDefaultCreditreformCompactReport,
    },
    risk_check_report: {
      externalLink:
        "https://docs.taktile.com/third-party-connections/built-in-connection-nodes/credit-bureaus/creditreform#risk-check-risiko-check",
      integrationResource: getDefaultCreditreformRiskCheckReport,
    },
    ecrefo_report: {
      externalLink:
        "https://docs.taktile.com/third-party-connections/built-in-connection-nodes/credit-bureaus/creditreform#ecrefo-report",
      integrationResource: getDefaultCreditreformEcrefoReport,
    },
    identification_report: {
      externalLink:
        "https://docs.taktile.com/third-party-connections/built-in-connection-nodes/credit-bureaus/creditreform#searching-for-a-company",
      integrationResource: getDefaultCreditreformIdentificationReport,
    },
    search_request: {
      externalLink:
        "https://docs.taktile.com/third-party-connections/built-in-connection-nodes/credit-bureaus/creditreform#searching-for-a-company",
      integrationResource: getDefaultCreditreformSearchRequest,
    },
    traffic_light_report: {
      externalLink:
        "https://docs.taktile.com/third-party-connections/built-in-connection-nodes/credit-bureaus/creditreform#traffic-light-report-ampelauskunft",
      integrationResource: getDefaultCreditreformTrafficLightReport,
    },
    creditreform_mailbox_directory: {
      externalLink:
        "https://docs.taktile.com/third-party-connections/built-in-connection-nodes/credit-bureaus/creditreform#commercial-report-mailbox-directory",
      integrationResource: getDefaultCreditreformMailboxDirectory,
    },
    creditreform_mailbox_entry: {
      externalLink:
        "https://docs.taktile.com/third-party-connections/built-in-connection-nodes/credit-bureaus/creditreform#commercial-report-mailbox-entry",
      integrationResource: getDefaultCreditreformMailboxEntry,
    },
  },
};
